import axios from 'axios';

const BrokerTeamService = {
  async createBrokerTeam(formValues) {
    const response = await axios.post('/broker-teams/', formValues);

    return response.data;
  },

  async getBrokerTeams({ brokerIds }) {
    const response = await axios.get('/broker-teams', {
      params: { brokerIds },
    });

    return response.data;
  },

  async getBrokerTeam(id) {
    const response = await axios.get(`/broker-teams/${id}`);

    return response.data;
  },

  async deleteBrokerTeam(id) {
    const response = await axios.delete(`/broker-teams/${id}`);

    return response.data;
  },

  async updateBrokerTeam({ id, formValues }) {
    const response = await axios.patch(`/broker-teams/${id}`, formValues);

    return response.data;
  },

  async getBrokerTeamUsers(id) {
    const response = await axios.get(`/broker-teams/${id}/users`);

    return response.data;
  },

  async addUserToBrokerTeam({ id, userId }) {
    const response = await axios.post(`/broker-teams/${id}/users/${userId}`);

    return response.data;
  },

  async removeUserFromBrokerTeam({ id, userId }) {
    const response = await axios.delete(`/broker-teams/${id}/users/${userId}`);

    return response.data;
  },
};

export default BrokerTeamService;
